import { defaultTheme } from '@hn-ui/themes';
var ActivityColorsByStatus = {
    completed: defaultTheme.colors.green50,
    expired: defaultTheme.colors.red50,
    canceled: defaultTheme.colors.red50,
    in_progress: defaultTheme.colors.black50,
    canceled_by_card: defaultTheme.colors.black50,
    canceled_by_teacher: defaultTheme.colors.black50,
    canceled_by_time: defaultTheme.colors.black50,
    not_started: defaultTheme.colors.black50,
    scheduled: defaultTheme.colors.black50,
};
export { ActivityColorsByStatus };
